import axios from 'axios'
import store from "@/store";
import settingsService from "@/_services/settings-service";

export default {
  baseUrl() {
      return settingsService.get("accountUrl");
  },

  forgotUsername(email){
    const url = this.baseUrl() + 'Account/ForgotUsername/' + email
    return axios.post(url, {}).then(response => {
      return response.data
    })
  },

  login(user) {
    store.commit("isLoading");
    const url = this.baseUrl() + 'Account'
    return axios.post(url, user)
      .then(result => { 
        if (result.data.statusCode === 200) {
          var token = this.parseToken(result.data.data);
          console.log("Token:", token)
          store.commit("loginUser", token);
          var userToken = token.TOKEN
          var expires = token.EXPIRES
          this.keepToken(userToken, expires)
        }
        return result.data
      })
      .catch(error => { return {
        isValid: false,
        statusCode: 404,
        data: error,
        errors: ["Login failed"],
      }})
      .finally(() => {
        store.commit("notLoading");
      })
  },

  logout(id) {
    store.commit("isLoading");
    const url = this.baseUrl() + 'Account/Logout/' + id
    return axios.post(url)
      .then(result => { 
        return result.data
      })
      .catch(error => { return {
        isValid: false,
        statusCode: 404,
        data: error,
        errors: ["Logout failed"],
      }})
      .finally(() => {
        store.commit("notLoading");
      })
  },

  reset(email) {
    const url = this.baseUrl() + 'Account/Reset/' + email
    return axios.post(url, {}).then(response => {
      return response.data
    })
  },

  resetPassword(user) {
    const url = this.baseUrl() + 'Account/PasswordReset'
    return axios.post(url, user).then(response => {
      return response.data
    })
  },

  register(user) {
    const url = this.baseUrl() + 'Account/'
    return axios.put(url, user).then(response => {
      return response.data
    })
  },

  refresh(token) {
    const url = this.baseUrl() + 'Account/Refresh/' + token
    return axios.post(url, {}).then(result => {
      if (result.data.statusCode === 200) {
        var token = this.parseToken(result.data.data);
        store.commit("loginUser", token);
        var userToken = token.TOKEN
        var expires = token.EXPIRES
        this.keepToken(userToken, expires)
      }
      return result.data
  })
  },

  parseToken(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  },

  keepToken(token, expires) {
    const deadline = expires
    const timeInterval = setInterval(() => {
      const t = this.getTimeRemaining(deadline)
      if(t.total <= 0) {
        clearInterval(timeInterval)
        this.refresh(token)
      }
    })
  },

  getTimeRemaining(endtime){
    const end = Date.parse(endtime)
    const now =  Date.parse(new Date())
    const total = end - now
    const seconds = Math.floor( (total/1000) % 60 );
    const minutes = Math.floor( (total/1000/60) % 60 );
    const hours = Math.floor( (total/(1000*60*60)) % 24 );
    const days = Math.floor( total/(1000*60*60*24) );
  
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  },

      delete(route, successCallback, errorCallback) {
        store.commit("isLoading");
        const url = this.baseUrl() + route
        // console.log("Delete: ", url)
        return axios.delete(url)
            .then(response => {
                console.log("Delete response from ", url)
                console.log(response)
                successCallback(response)
            })
            .catch(error => {
                console.log("Delete error from ", url)
                console.log(error)
                if (error.response) {
                    errorCallback(error.response.data)
                } else {
                    errorCallback(error)
                }
            })
            .finally(() => {
                store.commit("notLoading");
            })
    },

    get(route, successCallback, errorCallback) {
        // console.log("ApiUrl: ", process.env.VUE_APP_TEMPLATE_BASEURL)
        store.commit("isLoading");
        const url = this.baseUrl() + route;
        // console.log("Get: ", url)
        return axios.get(url)
            .then((response) => {
                // console.log("Get response from ", url)
                // console.log(response)
                if(response.data.jsonData != null){
                    var user = JSON.parse(response.data.jsonData);
                    user.isVerified = true;
                    user.userRoles = [];
                    // console.log("User: ", user);
                    store.commit("setUser", user);
                    store.commit("updateMenu");

                    const rolesUrl = "User/Roles/id?id=" + user.id;
                    this.get(rolesUrl, this.onUserRoles, this.onUserRolesError);
                }
                successCallback(response);
            })
            .catch(error => {
                console.log("Get error from ", url)
                console.log(error)
                if (error.response) {
                    errorCallback(error.response)
                } else {
                    errorCallback(error)
                }
            })
            .finally(() => {
                store.commit("notLoading");
            })
    },

    getFile(url, successCallback, errorCallback) {
        store.commit("isLoading");
        // console.log("getFile: ", url)
        return axios.get(url)
            .then((response) => {
                successCallback(response);
            })
            .catch(error => {
                if (error.response) {
                    errorCallback(error.response)
                } else {
                    errorCallback(error)
                }
            })
            .finally(() => {
                store.commit("notLoading");
            })
    },

    onUserRoles(data) {
        if(data != null) {
            var roles = data.data;
            var userRoles = [];
            roles.forEach(role => {
                userRoles.push(role.roleName);
            });
            var user = store.getters.getUser;
            user.userRoles = userRoles;
            store.commit("setUser", user);
            store.commit("updateMenu");
        }
    },

    onUserRolesError(error) {
        console.log("User Roles Error: ", error);
    },

    post(route, data, successCallback, errorCallback) {
        // console.log("ApiUrl: ", process.env.VUE_APP_TEMPLATE_BASEURL)
        store.commit("isLoading");
        console.log("Post: ", data)
        const url = this.baseUrl() + route;
        return axios.post(url, data)
            .then((response) => {
                successCallback(response);
                // console.log("Post response from ", url)
                // console.log(response)
            })
            .catch(error => {
                if (error.response) {
                    errorCallback(error.response)
                } else {
                    errorCallback(error)
                }
                console.log("Post error:", error)
            })
            .finally(() => {
                store.commit("notLoading");
            })
    },

    put(route, data, successCallback, errorCallback) {
        store.commit("isLoading");
        // console.log("Put: ", data)
        const url = this.baseUrl() + route;
        return axios.put(url, data)
            .then((response) => {
                successCallback(response);
                // console.log("Put response from ", url)
                // console.log(response)
            })
            .catch(error => {
                console.log("Put error from ", url)
                console.log(error)
                if (error.response) {
                    errorCallback(error.response)
                } else {
                    errorCallback(error)
                }
            })
            .finally(() => {
                store.commit("notLoading");
            })
    },

  store,
}
